module.exports = __webpack_public_path__ + "img/pcBanner14.a70dcb97.png";